function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DEFAULT_BREAKPOINTS = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
export const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/React.createContext({
  prefixes: {},
  breakpoints: DEFAULT_BREAKPOINTS,
  minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const Consumer = ThemeContext.Consumer,
  Provider = ThemeContext.Provider;
function ThemeProvider(_ref) {
  let _ref$prefixes = _ref.prefixes,
    prefixes = _ref$prefixes === void 0 ? {} : _ref$prefixes,
    _ref$breakpoints = _ref.breakpoints,
    breakpoints = _ref$breakpoints === void 0 ? DEFAULT_BREAKPOINTS : _ref$breakpoints,
    _ref$minBreakpoint = _ref.minBreakpoint,
    minBreakpoint = _ref$minBreakpoint === void 0 ? DEFAULT_MIN_BREAKPOINT : _ref$minBreakpoint,
    dir = _ref.dir,
    children = _ref.children;
  const contextValue = useMemo(() => ({
    prefixes: _objectSpread({}, prefixes),
    breakpoints,
    minBreakpoint,
    dir
  }), [prefixes, breakpoints, minBreakpoint, dir]);
  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
}
export function useBootstrapPrefix(prefix, defaultPrefix) {
  const _useContext = useContext(ThemeContext),
    prefixes = _useContext.prefixes;
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
export function useBootstrapBreakpoints() {
  const _useContext2 = useContext(ThemeContext),
    breakpoints = _useContext2.breakpoints;
  return breakpoints;
}
export function useBootstrapMinBreakpoint() {
  const _useContext3 = useContext(ThemeContext),
    minBreakpoint = _useContext3.minBreakpoint;
  return minBreakpoint;
}
export function useIsRTL() {
  const _useContext4 = useContext(ThemeContext),
    dir = _useContext4.dir;
  return dir === 'rtl';
}
function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  const isClassy = Component.prototype && Component.prototype.isReactComponent;
  // If it's a functional component make sure we don't break it with a ref
  const _opts = opts,
    prefix = _opts.prefix,
    _opts$forwardRefAs = _opts.forwardRefAs,
    forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
  const Wrapped = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
    let props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
    props[forwardRefAs] = ref;
    const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
      bsPrefix: bsPrefix
    }));
  });
  Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
  return Wrapped;
}
export { createBootstrapComponent, Consumer as ThemeConsumer };
export default ThemeProvider;